import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { useImpersonation } from '../../contexts/ImpersonationContext'

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()
  const { impersonation } = useImpersonation()
  const location = useLocation()

  // Sessione di impersonazione attiva — bypass auth Supabase
  if (impersonation) return <>{children}</>

  if (loading) {
    return (
      <div className="min-h-screen bg-[--km-bg] flex items-center justify-center">
        <p className="text-sm text-[--km-text-secondary]">Caricamento…</p>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />
  }

  return <>{children}</>
}
